import { useState, type FormEvent } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { createTrip } from '../api/trips';
import { HttpError } from '../api/client';

export function TripNewPage() {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const trip = await createTrip({
        title: title.trim(),
        description: description.trim() || null,
        startDate: startDate || null,
        endDate: endDate || null,
      });
      navigate(`/trips/${trip.id}`, { replace: true });
    } catch (err) {
      if (err instanceof HttpError) {
        setError(err.apiError.message);
      } else {
        setError('Errore di connessione');
      }
      setSubmitting(false);
    }
  }

  return (
    <div className="page">
      <div className="page-head">
        <h1>Nuovo viaggio</h1>
        <Link to="/trips" className="btn btn-ghost">
          ← Annulla
        </Link>
      </div>

      <form className="form-card" onSubmit={onSubmit}>
        <label>
          <span>Titolo *</span>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            autoFocus
            maxLength={200}
          />
        </label>

        <label>
          <span>Descrizione</span>
          <textarea
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={5000}
          />
        </label>

        <div className="row">
          <label>
            <span>Data inizio</span>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          </label>
          <label>
            <span>Data fine</span>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          </label>
        </div>

        {error && <p className="err">{error}</p>}

        <div className="actions">
          <button type="submit" disabled={submitting || !title.trim()}>
            {submitting ? 'Creazione…' : 'Crea viaggio'}
          </button>
        </div>
      </form>
    </div>
  );
}
